export interface ChargeDetailPrintCriteria {
    isPrint?: boolean | null,
    reportCategory?: string | null,
    radAdjustment?: string | null,
    radNormal?: string | null,
    printer?: string | null,
    rptList?: string[],

    chargeHdrId?: number | null,
    consortiumCode?: string | null,
    voyageCode?: string | null,
    vesselCode?: string | null,
    etdFrom?: Date | null,
    etdTo?: Date | null,
    opsDateFrom?: Date | null,
    OpsDateTo?: Date | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_CHARGE_DETAIL_PRINT_CRITERIA: ChargeDetailPrintCriteria = {
    isPrint: false,
    reportCategory: null,
    radAdjustment: "O",
    radNormal: null,
    printer: null,
    rptList: [],

    chargeHdrId: null,
    consortiumCode: null,
    voyageCode: null,
    vesselCode: null,
    etdFrom: null,
    etdTo: null,
    opsDateFrom: null,
    OpsDateTo: null,
}